export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/tests.c7f72783.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};